import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import store from '../../shared/Store';
import platformService from '../../core/services/platform.service';
import FeedbackModal from '../../components/cms/WorkshopFeedbackPopupBlock/FeedbackModal';

const FeedbackPopupBlock = ({ item, field, liveField }) => {
  const state = useRef({
    hasShown: false,
  });
  const [feedbackUrl, setFeedbackUrl] = useState(null);

  const hasStreaming = item[liveField] && item[liveField].length > 0;
  const hasFeedbacks = item[field] && item[field].length > 0;
  const feedbackFormUri = (item[field]?.[0] || {})?.uri;

  useEffect(() => {
    state.current.hasShown = false; // Reboot when item and/or feedback changes
  }, [item._id, feedbackFormUri]);

  useEffect(() => {
    if (hasFeedbacks && hasStreaming && !state.current.hasShown) {
      // eslint-disable-next-line no-inner-declarations
      async function check() {
        if (!feedbackFormUri) return;
        const api = `${feedbackFormUri.replace('/html', '/api')}/workshops/${item._id}/users/${
          store.userId
        }`;
        const res = await platformService.secureGet(api);
        if (res) {
          const { status, token } = res;
          if (status === 'display') {
            state.current.hasShown = true;
            // Generate workshop-specific uri
            setFeedbackUrl(`${feedbackFormUri}/workshops/${item._id}?token=${token}`);
          } else if (status === 'done') {
            state.current.hasShown = true;
            // Already good
          }
        }
      }
      check();
    }
  }, [hasFeedbacks, hasStreaming, item._id, feedbackFormUri]);

  if (!feedbackUrl || !feedbackFormUri) {
    return null;
  }

  return (
    <FeedbackModal item={item} onClose={() => setFeedbackUrl(null)} feedbackUrl={feedbackUrl} />
  );
};

FeedbackPopupBlock.defaultProps = {
  field: 'feedbacks',
  liveField: 'liveStreams',
};
FeedbackPopupBlock.propTypes = {
  field: PropTypes.string,
  liveField: PropTypes.string,
  item: PropTypes.object.isRequired,
};

export default FeedbackPopupBlock;
